import { render, staticRenderFns } from "./ArtworkProductsDialog.vue?vue&type=template&id=3e807550&scoped=true"
import script from "./ArtworkProductsDialog.vue?vue&type=script&lang=js"
export * from "./ArtworkProductsDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtworkProductsDialog.vue?vue&type=style&index=0&id=3e807550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e807550",
  null
  
)

export default component.exports